document.addEventListener('DOMContentLoaded', ()=>{
    new Swiper(".review-section-Mn .mySwiper", {
        slidesPerView: 1.2,spaceBetween: 7,
        navigation: {nextEl: ".review-section-Mn .swiper-button-next", prevEl: ".swiper-button-prev"},
        pagination: { el: ".review-section-Mn .swiper-pagination", clickable: true },
        breakpoints: {
            0: { slidesPerView: 1.1 },
            768: { slidesPerView: 1.2 },
            1024: { slidesPerView: 3.5 }
        }
    });
    document.querySelectorAll('.withapp_imagnary__layout.swiper').forEach((el)=>{
        new Swiper(el, {
            slidesPerView: 'auto',
            navigation: {nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"},
            pagination: { el: ".swiper-pagination",type: "fraction"},
            breakpoints: {
                0: { spaceBetween: 10 },
                750: { spaceBetween: 0 }
            }            
        });    
    })
    document.querySelectorAll('.band__comparaison_accordion_name').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            if( target.target.closest('.band__comparaison_accordion_tab').classList.contains('active') ){
                target.target.closest('.band__comparaison_accordion_tab').classList.remove('active');
                target.target.closest('.band__comparaison_accordion_tab').querySelector('.band__comparaison_accordion_content').style.maxHeight = null;
            }else{
                document.querySelectorAll('.band__comparaison_accordion_tab').forEach((elm)=>{ elm.classList.remove('active'); elm.querySelector('.band__comparaison_accordion_content').style.maxHeight = null; });
                target.target.closest('.band__comparaison_accordion_tab').classList.add('active');
                let mainTabContent = target.target.closest('.band__comparaison_accordion_tab').querySelector('.band__comparaison_accordion_content');
                mainTabContent.style.maxHeight = `${mainTabContent.scrollHeight}px`;            
            }
            setTimeout(()=>{
                window.scrollTo({
                top: document.querySelector('.band__comparaison_content_lyt').offsetTop - 158,
                behavior: 'smooth'
                });          
            },100)
        })
    })  
    document.querySelectorAll('.withmap__main_imagnary').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            if( window.screen.width > 750){
                if( target.target.closest('.withapp_imagnery__items').classList.contains('active') ){
                    target.target.closest('.withapp_imagnery__items').classList.remove('active');
                    target.target.closest('.withapp_imagnery__items').querySelector('.min-thumb-image').style.height = `0px`;
                }else{
                    target.target.closest('.withapp_imagnary__wrapper').querySelectorAll('.withapp_imagnery__items').forEach((el)=>{el.querySelector('.min-thumb-image').style.height = `0px`; el.classList.remove('active');});
                    target.target.closest('.withapp_imagnery__items').classList.add('active');
                    let eligibleHeight = target.target.closest('.withapp_imagnery__items').getAttribute('has-height');
                    target.target.closest('.withapp_imagnery__items').querySelector('.min-thumb-image').style.height = eligibleHeight;
                }
                setTimeout(()=>{
                    window.scrollTo({
                    top: target.target.closest('.withapp_imagnary__layout_CT').offsetTop - 100,
                    behavior: 'smooth'
                    });          
                },100) 
            }
        })
    }) 
    // const elements = document.querySelectorAll(".shouldbeTranform_with");
    // const observer = new IntersectionObserver(
    // (entries) => {
    //     entries.forEach((entry, index) => {
    //     const el = entry.target;
    //     const ratio = entry.intersectionRatio;
    //     if (entry.isIntersecting) {
    //         const delay = [...elements].indexOf(el) * 50;
    //         el.style.transition = `transform 0.8s ease ${delay}ms, opacity 0.8s ease ${delay}ms`;
    //         el.style.transform = "translateY(0%)";
    //         el.style.opacity = "1";
    //     } else {
    //         el.style.transition = "transform 0.3s ease, opacity 0.3s ease";
    //         el.style.transform = "translateY(100%)";
    //         el.style.opacity = "0";
    //     }
    //     });
    // },
    // {
    //     threshold: Array.from({ length: 101 }, (_, i) => i / 100),
    // }
    // );
    // elements.forEach((el) => {
    //     el.style.transform = "translateY(100%)";
    //     el.style.opacity = "0";
    //     el.style.willChange = "transform, opacity";
    //     observer.observe(el);
    // });    
    function isInViewportStickyElement(elem) { 
        var bounding = elem.getBoundingClientRect();
        var myElementHeight = elem.offsetHeight;
        var myElementWidth = elem.offsetWidth;
        return (bounding.top >= -myElementHeight && bounding.left >= -myElementWidth && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) ; 
    }; 
    
    var recommendationElementTest = document.querySelectorAll('.mapwithouttest');
    window.addEventListener('scroll', ()=>{
        recommendationElementTest.forEach( (evt)=>{
        if ( isInViewportStickyElement(evt) ) {
            document.querySelectorAll(".withoutabteststk").forEach((target)=>{
            target.classList.add('hidden');
            });
        }else{
            document.querySelectorAll(".withoutabteststk").forEach((target)=>{
            target.classList.remove('hidden');
            });
        }
        })
    })
    
    const videoWrapper = document.querySelector('.TextRow__VideoWrapper, .WillNotShowOnBodyPodPDMN');
    const scrollingBar = document.querySelector('.ListScrollingBarWp');
    const announcementBar = document.querySelector('#shopify-section-announcement-bar');

    function handleScroll() {
        const scrollPosition = window.scrollY;
        if (videoWrapper) {
        const showBuyBarPosition = videoWrapper.offsetTop;
        if (scrollPosition > showBuyBarPosition) {
            scrollingBar.classList.add('active');
            document.body.classList.add('HiddenHeaderBar');
        } else {
            scrollingBar.classList.remove('active');
            document.body.classList.remove('HiddenHeaderBar');
        }
        }
        const announcementBarHeight = announcementBar.offsetHeight;
        scrollingBar.style.top = `${announcementBarHeight}px`;
    }
    window.addEventListener('scroll', handleScroll);    

    var quantity = document.querySelector('.quantity-control-button.add'); if(quantity){ quantity.addEventListener('click', function(e){ e.preventDefault(); var inputElement  = this.closest('.number-input-control').querySelector('.input-text'); var inputValue = parseInt(inputElement.value) || 0; inputElement.value = inputValue + 1; }) }
    var minusQuantity = document.querySelector('.quantity-control-button.subtract'); if(minusQuantity){ minusQuantity.addEventListener('click', function(e){ e.preventDefault(); var inputElement  = this.closest('.number-input-control').querySelector('.input-text'); var inputValue = parseInt(inputElement.value) || 0; if (inputValue > 1) { inputElement.value = inputValue - 1; }})}    
    var popupContentWrapper = document.querySelectorAll(".hsa-fsa-popup-content-wrapper"); if(popupContentWrapper.length){ popupContentWrapper.forEach(function(popup){ popup.addEventListener("click", function() { document.body.classList.add("hsa-popup-open"); document.querySelector(".hsapopupContainer").classList.add("active-open"); }); }) }
    var closeButtn = document.querySelector('.hsapopupContainer .hsaCrsBtn'); if(closeButtn){ closeButtn.addEventListener('click', function() { document.body.classList.remove('hsa-popup-open'); document.querySelector('.hsapopupContainer').classList.remove('active-open'); }); }
    document.addEventListener('click', function(event) {
        var targetElement = event.target.closest('.Wphyopyiomshy');
        if (targetElement) { 
            event.preventDefault();
            targetElement.classList.add('active');
            var siblings = targetElement.parentNode.querySelectorAll('.Wphyopyiomshy');
            siblings.forEach(function(sibling) {
            if (sibling !== targetElement) {
                sibling.classList.remove('active'); 
            } 
            });
        } 
    });   
    
    var oncliickpopup= document.querySelectorAll('.Wphyopyiomshy');
    if(oncliickpopup.length > 0){ 
        oncliickpopup.forEach((el)=>{
            el.addEventListener('click', function (evt) {
                evt.preventDefault();
                if( evt.target.closest('.Wphyopyiomshy').classList.contains('OnlyAvailThat')){
                    document.querySelector('.OneClick_Popup').classList.remove('show-checked');
                }else{
                    document.querySelector('.OneClick_Popup').classList.add('show-checked');
                }
             })
        })
    }

    document.querySelector('.OneClick_Popup').addEventListener('click', function(evt){
    evt.preventDefault();
    if (!this.classList.contains('show-checked')) {
        let thisElm = this;
        thisElm.classList.add('clickedMe');
        var mainID = this.getAttribute('main-productid'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
        formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
        .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
        .then(data => {
        thisElm.classList.remove('clickedMe');
        window.location.href = '/checkout'; 
        }) 
    }else if(this.classList.contains('WarrantyDisabledPopup')){
        let thisElm = this;
        thisElm.classList.add('clickedMe');
        var mainID = this.getAttribute('data-without-popup'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
        formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
        .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
        .then(data => {
        thisElm.classList.remove('clickedMe');
        window.location.href = '/checkout'; 
        })      
    }else{
        document.querySelector('.Product_Popup').classList.add('popup-open'); document.body.classList.add('popup-show');
    }
    })

    document.querySelectorAll('.accordianjshandle').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            target.target.closest('.custom-faqs-Items').classList.toggle('active');
        });
    });  

    let ScrollTargetPDP = document.querySelectorAll(".ScrollerPdpAtc, .Dsrgyu, .Humeband-block-button, [js-scroll-to-destination] ");
    ScrollTargetPDP.forEach((evt)=>{
        evt.addEventListener('click', (target)=>{
            target.preventDefault();
            if(window.innerWidth > 769){
            var targetElement = document.querySelector('.MainProductRightPortionWp');
            window.scrollTo({
                top: targetElement.offsetTop - document.querySelector('#shopify-section-announcement-bar').clientHeight,
                behavior: 'smooth'
            });
            }else{
            var targetElement = document.querySelector('.WarrantyProtectionWp');
            window.scrollTo({
                top: targetElement.offsetTop - 120,
                behavior: 'smooth'
            });
            }  
        })
    });

    document.querySelectorAll('.wpunijtysh').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
        target.preventDefault();
        if( target.currentTarget.classList.contains('TargetToDivElement') ){
        var targetElement = document.querySelector('.WidgetreviewsLoader');
        if ( window.screen.width > 769) {
            window.scrollTo({
            top: targetElement.offsetTop - 158,
            behavior: 'smooth'
            });    
        }else{
            window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
            });           
        }        
        }else{
        target.target.closest('.Tabinityiniopsmkm').classList.toggle('active');
        }
    });
    });     
    
  document.querySelectorAll('.Tilemnexh').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      target.target.closest('.CollpsmnTabex').classList.toggle('active');
    });
  });

})
